// extracted by mini-css-extract-plugin
export var loaderBounce = "Loader-module--loaderBounce--aefe5";
export var loaderSpinner = "Loader-module--loaderSpinner--c329c";
export var second = "Loader-module--second--fb15e";
export var skBounce = "Loader-module--sk-bounce--025dc";